import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab, Modal, Button, Form } from 'react-bootstrap';
import { Initial } from 'react-initial'
import ReactPaginate from 'react-paginate';
import DataTable from 'react-data-table-component';
import { formatTime, getFlexClasses, getInstructorDetails, getInstructorList, getLanguage, getInstructorDetailsWithSchedule } from '../../Utils/utils';
import moment from "moment/moment";
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@mui/material/LinearProgress';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import LoadingSpinner from "../LoadingSpinner";
import Select from 'react-select';
import { ToastContainer } from "react-toastify";
import axios from "axios";
import config from "../../config/config";
import { getStartDate } from "../../Utils/dates";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

const SetupModal = (props) => {
  const { showModal, setShowModal, lang_id, setIsSetup, setCloseRow, selectedRow, setSelectedRow, closeRow, showTime, newInstArr, fromGrouped, isIstructorValue = false } = props;
  const [showInstDetail, setShowInstDetail] = useState(false);
  const [isNoInst, setIsNoInst] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [instList, setInstList] = useState([]);
  const [instVal, setInstVal] = useState('');
  const [tempInstructorName, setTempInstructorName] = useState('');
  const [instDetail, setInstDetail] = useState('');
  const [isInstructorAccepted, setIsInstructorAccepted] = useState(isIstructorValue);
  const [isDisable, setIsDisable] = useState(true);
  const [isDisableBtn, setIsDisableBtn] = useState(true);
  const [classtimingdetails, setClasstiminingdetails] = useState([])
  const [selectedTimings, setSelectedTimings] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [newDate, setNewDate] = useState(new Date());

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const getInstructor = async () => {
    var temp = []
    var res = await getInstructorList(lang_id, selectedRow.mainClassNumber)
    res.map((e) => {
      temp.push({
        value: e.id, label: e.first_name + ' ' + e.last_name, language_id: e.select_language
      })
    })
    setInstList(temp)
  }

  useEffect(() => {
    getInstructor()
  }, [lang_id, selectedRow?.mainClassNumber])


  const getInstructorDetail = async (val, lang) => {
    if (val != "-2") {
      const res = await getInstructorDetailsWithSchedule(
        val,
        lang,
        selectedRow?.newMatchedTimings,
        selectedRow?.mainClassNumber,
        selectedRow?.availableStartDate
      );

      console.log(res, "res......");

      if (res.status == 200) {
        setInstDetail(res.data.data);
        return res.data.data;
      }
    } else {
      setInstDetail('');
    }

    return null;
  };


  useEffect(() => {
    if (instVal !== "") {
      getInstructorDetail(instVal.value, instVal.language_id)
    }
  }, [instVal])






  const saveSetup = async () => {

    setShowModal(false)
    setIsSetup(true)

    if (instVal?.value == -2) {
      selectedRow.instructorName = tempInstructorName
      selectedRow.instructorId = -2
      selectedRow.instructorEmail = ""
      selectedRow.instructorAccepted = false
      selectedRow.isReadyToApprove = true
      selectedRow.newMatchedTimings = selectedTimings;
      selectedRow.availableStartDate = moment(startDate).format("YYYY-MM-DD");
    } else {
      selectedRow.instructorName = `${instDetail?.first_name} ${instDetail?.last_name}`
      selectedRow.instructorId = instDetail?.id
      selectedRow.instructorEmail = `${instDetail?.email}`
      selectedRow.instructorAccepted = isInstructorAccepted
      selectedRow.isReadyToApprove = true
      selectedRow.newMatchedTimings = selectedTimings;
      selectedRow.availableStartDate = moment(startDate).format("YYYY-MM-DD");
    }

    setSelectedRow({ ...selectedRow });
  }

  // useEffect(() => {
  //   console.log(selectedRow, "123123");
  //   if (selectedRow?.instructorId !== null) {

  //     setShowInstDetail(true)
  //     getInstructorDetail(selectedRow?.instructorId, selectedRow.language?.id)
  //     setIsDisable(false)
  //   }
  // }, [selectedRow])

  useEffect(() => {
    if (instList.length > 0) {
      const match = instList.find(i => i.value === selectedRow.instructorId);
      setInstVal(match || '');
    }

    if (selectedRow?.instructorId !== null) {
      setShowInstDetail(true);
      // getInstructorDetail(selectedRow?.instructorId, selectedRow.language?.id).then((data) => {
      //   if (data?.updated_schedule?.length > 0) {
      //     setSelectedRow((prev) => ({
      //       ...prev,
      //       newMatchedTimings: data.updated_schedule,
      //     }));
      //   }
      // });
      getInstructorDetail(selectedRow?.instructorId, selectedRow.language?.id).then((data) => {
        if (data?.updated_schedule?.length > 0) {
          setSelectedTimings(data.updated_schedule);
        }
      });
      setIsDisable(false);
    }
    setSelectedTimings(selectedRow?.newMatchedTimings || []);

    const today = moment().startOf("day");
    const available = moment(selectedRow?.availableStartDate).startOf("day");
    const finalDate = available.isAfter(today) ? available : today;
    setNewDate(new Date(finalDate))
  }, [selectedRow, instList]);

  // console.log(selectedRow, "selected row.....")

  useEffect(() => {
    // console.log(instDetail,"instDetail.....")
  }, [instDetail])

  useEffect(() => {
    setStartDate(getStartDate(selectedTimings, newDate));
  }, [selectedTimings]);

  const newSelectedDate = (date) => {
    setNewDate(date)
    setStartDate(getStartDate(selectedTimings, date))
    toast.success("Your class start date has been updated based on your selected class days. Click on Save Changes to apply the update.", {
      onOpen: (props, ...args) => console.log("toast opened with options:", props, args),
    })
  }

  return (
    <>
      <div>
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            {fromGrouped == 1 ?
              <Modal.Title> View Class Times </Modal.Title>
              :
              <Modal.Title> Select Class Times</Modal.Title>
            }
          </Modal.Header>
          <Modal.Body>
            {fromGrouped == 1 ? null :
              <Row>
                <Col md={6}>
                  <div className="modal-select">
                    <Select
                      name="colors"
                      options={instList}
                      value={instVal}
                      className="basic-multi-select "
                      classNamePrefix="select"
                      placeholder="Please select instructor"
                      onChange={(e) => {
                        setIsDisable(false)
                        setInstVal(e)
                        if (e.value == -2) {
                          setShowInstDetail(false)
                        } else {
                          setShowInstDetail(true)
                        }

                      }}
                    />
                  </div>
                </Col>
                {instVal?.value == "-2" ?
                  <Col md={6}>
                    <div className="mb-3">
                      <input className="form-control mb-2" type="text" name="instructor_name"
                        placeholder={("Enter instructor name")} onChange={(e) => setTempInstructorName(e.target.value)}
                      />
                    </div>
                  </Col> : null}
              </Row>
            }
            {showInstDetail == true ?
              <>
                <Row className="mb-2 mt-3">
                  <Col md={4}>
                    <div className="inst-det">
                      First Name:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets">
                      {instDetail?.first_name}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Last Name:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets">
                      {instDetail?.last_name}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Phone number:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets">
                      {instDetail?.phone}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Email:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets" style={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}>
                      {instDetail?.email}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Work Schedule:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets"
                      style={{
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        wordBreak: 'break-word',
                      }}
                    >
                      {instDetail?.days_hours}
                    </div>
                  </Col>
                </Row>
                <Form>
                  <Row className="mb-3 mt-3">
                    <Col md={7}>
                      <Form.Check
                        type={'radio'}
                        name="group1"
                        className="setup"
                        // checked={fromGrouped == 1 ? selectedRow?.instructorAccepted != 1 ? true : false : null}
                        //checked={selectedRow?.instructorAccepted != 1 ? true : false}
                        //checked={selectedRow?.instructorAccepted}
                        checked={isInstructorAccepted === false}
                        onChange={() => {
                          setIsInstructorAccepted(false)
                          //saveSetup()
                        }}
                        label={`Request Instructor Acceptance`}
                        id={`default-radio-1`}
                      />
                    </Col>
                    <Col md={5}>
                      <Form.Check
                        type={'radio'}
                        className="setup"
                        name="group1"
                        // checked={fromGrouped == 1 ? selectedRow?.instructorAccepted == 1 ? true : false : null}
                        //checked={selectedRow?.instructorAccepted}
                        //checked={true}
                        checked={isInstructorAccepted === true}
                        onChange={() => {
                          setIsInstructorAccepted(true)
                          //saveSetup()
                        }}
                        label={`Instructor Accepted`}
                        id={`default-radio-2`}
                      />
                    </Col>
                  </Row>

                </Form>
              </>
              : null}
            <Row className="mb-2 mt-2">
              <Col md={4}>
                <div className="inst-det">
                  Class Start Date:
                </div>
              </Col>
              <Col md={4}>
                <div className="inst-dets">
                  {/* {moment(selectedRow?.availableStartDate).isBefore(startDate)
                    ? moment(startDate).format("MM/DD/YYYY")
                    : moment(selectedRow?.availableStartDate).format('MM/DD/YYYY')} */}
                  {moment(startDate).format("MM/DD/YYYY")}
                </div>
              </Col>
              <Col md={4}>
                Change date
                <DatePicker selected={new Date()} onChange={(date) => newSelectedDate(date)} minDate={new Date()} customInput={<i className="text-primary fas fa-calendar-alt ml-3" style={{ cursor: "pointer", marginLeft: "6px" }} title="Choose Date">
                </i>} />
              </Col>
            </Row>
            <Form>
              <Row className="mb-3 mt-3">
                {!showTime && (
                  
                  instDetail?.updated_schedule?.length > 0 ? (
                                        // (allValues ? instDetail.updated_schedule : instDetail.updated_schedule.filter((t) => t.isSelected))
                                        instDetail.updated_schedule.map((time, index) => {
                                          const timee = time.classTime.split('-');
                                          const toTime = timee[1].slice(0, -3);
                                          return (
                                            <Col md={6} className="mb-2" key={index}>
                                              <>
                                                <input
                                                  type="checkbox"
                                                  name={`group${index}`}
                                                  disabled={time.isConflictWithInstructor || isDisable}
                                                  className={`setup ${time.isConflictWithInstructor ? "conflict-disabled" : ""}`}
                                                  // disabled={isDisable}
                                                  // className={`setup ${isDisable ? "conflict-disabled" : ""}`}
                                                  id={`default-checkbox-${index}`}
                                                  checked={selectedTimings[index]?.isSelected}
                                                  onChange={(e) => {
                                                    setIsDisableBtn(false);
                                                    // time.isSelected = !time.isSelected;
                                                    setSelectedTimings(prev =>
                                                      prev.map((t, i) =>
                                                        i === index ? { ...t, isSelected: !t.isSelected } : t
                                                      )
                                                    );
                                                  }}
                                                />
                                                <span className="ms-2">{`${time.classDay}: ${formatTime(timee[0], toTime)} EST`}</span>
                                              </>
                                            </Col>
                                          );
                                        })
                                      ) : 

                  
                  
                  selectedRow?.newMatchedTimings?.length > 0 ? (
                    selectedRow.newMatchedTimings.map((time, index) => {
                      const [fromTime, toFullTime] = time.classTime.split("-");
                      const toTime = toFullTime.slice(0, -3);

                      return (
                        <Col md={6} className="mb-2" key={index}>
                          <input
                            type="checkbox"
                            name={`group${index}`}
                            disabled={time?.isConflictWithInstructor || isDisable}
                            className={`setup ${time?.isConflictWithInstructor ? "conflict-disabled" : ""}`}
                            id={`default-checkbox-${index}`}
                            checked={selectedTimings[index]?.isSelected}
                            onChange={() => {
                              setIsDisableBtn(false);
                              // time.isSelected = !time.isSelected;
                              setSelectedTimings(prev =>
                                prev.map((t, i) =>
                                  i === index ? { ...t, isSelected: !t.isSelected } : t
                                )
                              );
                            }}
                          />
                          <span className="ms-2">
                            {`${time.classDay}: ${formatTime(fromTime, toTime)} EST`}
                          </span>
                        </Col>
                      );
                    })
                  ) : (
                    newInstArr.map((a, index) => (
                      <Col md={6} className="mb-2" key={index}>
                        <input
                          type="checkbox"
                          name={`group${index}`}
                          disabled={isDisable}
                          className="setup"
                          id={`default-checkbox-${index}`}
                          onChange={() => {
                            // Placeholder
                          }}
                        />
                        {`${a} EST`}
                      </Col>
                    ))
                  )
                )}
              </Row>




              {/* <Row className="mb-3 mt-3">
  {showTime === true ? null : (
    selectedRow?.newMatchedTimings?.length > 0 ? (
      selectedRow.newMatchedTimings.map((time, index) => {
        const timee = time.classTime.split("-");
        const toTime = timee[1].slice(0, -3);

        return (
          <Col md={6} className="mb-2" key={index}>
            <input
              type="checkbox"
              name={`group${index}`}
              disabled={isDisable}
              className="setup"
                 id={`default-checkbox-${index}`}
              onChange={(e) => {
                 setIsDisableBtn(false);
                 time.isSelected = !time.isSelected;
              }}
            />
            <span className="ms-2">{`${time.classDay}: ${formatTime(timee[0], toTime)} EST`}</span>
          </Col>
        );
      })
    ) : (
      newInstArr.map((a, index) => (
        <Col md={6} className="mb-2" key={index}>
          <input
            type="checkbox"
            name={`group${index}`}
            disabled={isDisable}
            className="setup"
            id={`default-checkbox-${index}`}
            onChange={() => {
              // placeholder if needed
            }}
          />
          {`${a} EST`}
        </Col>
      ))
    )
  )}
</Row>    */}


            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            {fromGrouped == 1 ? null :
              <Button variant="primary"
                //disabled={isDisableBtn}
                disabled={(isInstructorAccepted && !selectedTimings?.some(t => t.isSelected))}
                onClick={() => {
                  saveSetup()
                }}>
                Save Changes
              </Button>
            }
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default SetupModal